import { cn } from "@/libs/cn";
import { Button } from "@/components/shadcn/button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/shadcn/popover"
import { Icon } from "@iconify-icon/solid";

import { createSignal, For, Show } from "solid-js";
import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";
import { ChoiceFilter } from "./ChoiceFilter";
import { DateFilter } from "./DateFilter";

export const ListFilter = (props) => {

  const [filter, setFilter] = createSignal(false);
  const [open, setOpen] = createSignal(false);
  const renderFilter = () => {
    const type = filter().type;
    if (type === 'choice') {
      return <ChoiceFilter
        filter={filter()}
        onFilter={props.onFilter}
        onBack={() => setFilter(false)}
        onClose={() => setOpen(false)}
        />;
    }

    if (type === 'date') {
      return <DateFilter
        filter={filter()}
        onFilter={props.onFilter}
        onBack={() => setFilter(false)}
        onClose={() => setOpen(false)}
        />;
    }
  }

  return (
    <Popover placement="bottom-end" class="inline" open={open()} onOpenChange={(isOpen) => !isOpen && setFilter(false)}>
      <PopoverTrigger
        onClick={() => setOpen(!open())}
        as={(innerProps) => <Button variant={"outline"}
          class={cn(
            "justify-center items-center font-normal h-9 w-9",
            "text-muted-foreground",
            props.inputClass
          )} {...innerProps} />}>
        <Icon width="21" icon="bi:filter" />
      </PopoverTrigger>
      <PopoverContent class="w-auto p-0" showCloseButton={false} onInteractOutside={() => { setOpen(false); setFilter(false); }}>
        <Show when={!filter()}>
          <div>
            <div class="flex relative items-center border-b border-black/10 dark:border-white/5">
              <TextFieldRoot class="space-y-0">
                <TextFieldLabel class="sr-only">Search filters</TextFieldLabel>
                <TextField class="placeholder:text-foreground-muted text-xs flex border-0 focus-visible:outline-none focus-visible:ring-0 focus:outline-none focus:ring-0 dark:bg-transparent h-8 w-full rounded-md bg-transparent shadow-none py-3 sm:text-xs outline-none disabled:cursor-not-allowed disabled:opacity-50" placeholder="Search filters..." />
              </TextFieldRoot>
              <Button variant='outline' class="p-1 absolute right-2 flex items-center justify-center h-5 w-6" onClick={() => setOpen(false)}>
                <Icon icon="ion:close" />
              </Button>
            </div>
            <div class="py-1 px-1">
              <For each={props.filters}>
                {(filter) => (
                  <div class="flex items-center px-2 py-2 justify-between cursor-pointer gap-y-1 rounded-md hover:bg-black/5 dark:hover:bg-white/5" onClick={() => setFilter(filter)}>
                    <Show when={filter.icon}>
                      <Icon icon={filter.icon} class="me-1" />
                    </Show>
                    <span class="text-muted-foreground text-xs me-2">{filter.label}</span>
                  </div>
                )}
              </For>
            </div>
          </div>
        </Show>
        <Show when={filter()}>
          {renderFilter()}
        </Show>
      </PopoverContent>
    </Popover>
  );
}
